import * as BABYLON from '@babylonjs/core/Legacy/legacy';
import { Rectangle, Control } from '@babylonjs/gui/2D';

import { GameScene } from '../scene.js';

const log = console.log.bind(console);

export class CoinPannel {
    private coins: number;
    private control: Control;

    constructor() {

    }

    getControls(): Control[] {
        return []
    }

    update() {
        
    }
}